var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { filter, find, get } from 'lodash';
import { useContext } from 'react';
import { FooterMenuContext } from '../context/footer-menu-context';
import { useEnv } from '../hooks/use-env';
import { useMenus } from '../hooks/use-menus';
import { useSite } from '../hooks/use-site';
export var useFooterSecondaryMenu = function () {
  var site = useSite();
  var allMenus = useMenus() || [];
  var context = useContext(FooterMenuContext);
  var env = useEnv();
  var menuSlug = get(site, 'footerSecondaryMenu.slug', env.FOOTER_SECONDARY_MENU_SLUG || '');
  var cookieSettingsItem = {
    id: 'cookie-settings',
    slug: 'cookie-settings',
    name: 'Cookie Settings',
    path: '#cookie-settings'
  };
  var menu = find(allMenus, function (menu) {
    return menu.slug === menuSlug;
  });
  if (!menu) {
    return {
      id: 'site-footer-secondary-menu-auto',
      items: filter([site.termsPage && {
        id: 'site-footer-secondary-menu-auto-terms-item',
        page: site.termsPage
      }, site.privacyPolicyPage && {
        id: 'site-footer-secondary-menu-auto-privacy-item',
        page: site.privacyPolicyPage
      }, cookieSettingsItem])
    };
  }
  // add cookie settings item
  menu.items = __spreadArray(__spreadArray([], __read(filter(menu.items, function (item) {
    return item.id !== 'cookie-settings';
  })), false), [{
    id: 'cookie-settings',
    slug: 'cookie-settings',
    name: 'Cookie Settings',
    path: '#cookie-settings'
  }], false);
  // legacy fallback
  return context || menu;
};